<template>
  <el-form ref="form" :model="curInput.link" :rules="rules" label-width="100px">
    <el-form-item label="类型" prop="type">
      <el-select v-model="curInput.link.type" placeholder="请选择类型" class="h-40 w-200">
        <el-option v-for="(item, index) in typeOption" :label="item.name" :value="item.id"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="表单" prop="model_id" v-show="curInput.link.type == CASCADER_SELF">
      <el-select v-model="curInput.link.model_id" placeholder="请选择表单" class="h-40 w-200">
        <el-option v-for="(item, index) in formList" :label="item.title + '(' + item.name + ')'" :value="item.id"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="选择级联关联字段" prop="link_field_id" v-show="curInput.link.type == CASCADER_SELF">
      <el-select v-model="curInput.link.link_field_id" placeholder="请选择级联关联字段" class="h-40 w-200">
        <el-option v-for="(item, index) in fieldList" :label="item.title" :value="item.field_id"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="选择显示名称字段" prop="show_field_id" v-show="curInput.link.type == CASCADER_SELF">
      <el-select v-model="curInput.link.show_field_id" placeholder="请选择显示名称字段" class="h-40 w-200">
        <el-option v-for="(item, index) in fieldList" :label="item.title" :value="item.field_id"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="筛选条件" prop="filter" v-show="curInput.link.type == CASCADER_SELF">
      <el-input v-model.trim="curInput.link.filter" class="h-40 w-200"></el-input>
      <div class="form-tips">支持等于==，不等于<>，大于>，小于<逻辑判断</div>
    </el-form-item>
    <el-form-item label="区域限制" prop="area_limit" v-show="curInput.link.type == CASCADER_PROVINCE">
      <el-radio-group v-model="curInput.link.area_limit">
        <el-radio :label="1">是</el-radio>
        <el-radio :label="0">否</el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item prop="area_config" v-show="curInput.link.type == CASCADER_PROVINCE && curInput.link.area_limit == 1">
      <el-select v-model="curInput.link.area_config" multiple placeholder="区域限制" class="h-40 w-200">
        <el-option v-for="(item, index) in cityData" :label="item.name" :value="item.id"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="选中结果显示" prop="result_show">
      <el-select v-model="curInput.link.result_show" placeholder="请选择选中结果显示" class="h-40 w-200">
        <el-option v-for="(item, index) in resultShowOption" :label="item.name" :value="item.id"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="是否有搜索功能" prop="has_search">
      <el-radio-group v-model="curInput.link.has_search">
        <el-radio :label="1">是</el-radio>
        <el-radio :label="0">否</el-radio>
      </el-radio-group>
    </el-form-item>
  </el-form>
</template>

<script>
  import http from '../../../assets/js/http'
  import modelConfig from '../../../config/modelConfig'
  export default {
    props: ['curInput'],
    data() {
      return {
        typeOption: [
          { id: 10, name: '自定义' },
          { id: 20, name: '国内省市区选择' }
        ],
        resultShowOption: [
          { id: 10, name: '完整显示' },
          { id: 20, name: '仅显示最后一级' }
        ],
        fieldList: [],
        formList: [],
        hasGetForm: false,
        inputChange: false,
        cityData: []
      }
    },
    created() {
      this.getFormList()
      if (this.curInput.link.model_id) {
        this.getFormField()
      }
      this.cityData = require('../../../data/city-data.json')
    },
    mixins: [http, modelConfig],
    methods: {
      getFormList() {
        let postData = {
          params: {
            status: 1
          }
        }
        this.apiGet('form/models', postData).then((res) => {
          if (res.code == 200) {
            this.formList = res.data.list
            this.hasGetForm = true
          } else {
            _g.dealError(this, res)
          }
        })
      },
      getFormField() {
        let postData = {
          params: {
            type: 1
          }
        }
        let id = this.curInput.link.model_id
        if (id) {
          this.apiGet(`form/models/${id}/fields`, postData).then((res) => {
            if (res.code == 200) {
              this.fieldList = res.data
            } else {
              _g.dealError(this, res)
            }
          })
        }
      },
      formChange() {
        this.getFormField()
      },
      resetModelField() {
        this.curInput.link.link_field_id = null
        this.curInput.link.show_field_id = null
      },
      setInputChange(value) {
        this.inputChange = value
      }
    },
    watch: {
      'curInput'() {
        this.setInputChange(true)
      },
      'curInput.link.model_id'() {
        this.formChange()
        if (this.inputChange) {
          return
        }
        this.resetModelField()
      },
      'curInput.link.area_limit'() {
        if (this.inputChange) {
          return
        }
        this.curInput.link.area_config = []
      },
      'curInput.link.type'() {
        if (this.inputChange) {
          return
        }
        this.curInput.link.area_limit = 0
        this.curInput.link.area_config = []
      },
      'inputChange'() {
        if (this.inputChange) {
          this.setInputChange(false)
        }
      }
    }
  }
</script>


// WEBPACK FOOTER //
// cascaderConfig.vue?5264b805